const getDocument = (id) => `
  *[_id == "${id}"]
`;

export default getDocument;
